export var ieltsModalVisibleSelector = function ieltsModalVisibleSelector(state) {
  return state && state.ielts_modal ? state.ielts_modal.modal_visible : false;
};
var getCurrentApplication = function getCurrentApplication(state) {
  return state && state.application ? state.application.application : null;
};
export var getApplicationIeltsScores = function getApplicationIeltsScores(state) {
  var application = getCurrentApplication(state);
  return application && application.student && application.student.test_scores && application.student.test_scores.ielts || {};
};
export var getStudentPersonalInformation = function getStudentPersonalInformation(state) {
  var application = getCurrentApplication(state);
  return application ? application.student.personal_information : {};
};